'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HistoryControl = require('./HistoryControl');

var _HistoryControl2 = _interopRequireDefault(_HistoryControl);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * replace the tag 'A', used to link to a new url
 * @module Link
 */


var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args)));

    _this.handleClick = function (event) {
      event.preventDefault(); //阻止浏览器默认事件

      if (_this.props.onClick && typeof _this.props.onClick === 'function') {
        _this.props.onClick();
      }

      var _this$props = _this.props,
          to = _this$props.to,
          href = _this$props.href,
          state = _this$props.state;

      if (!to) {
        to = href;
      }

      if (typeof to === 'undefined' || to === null) {
        return;
      }

      if (!to) {
        to = '/';
      }

      if (to.indexOf('#') === 0) {
        to = to.substring(1);
      }

      if (to.indexOf('/') !== 0) {
        to = '/' + to;
      }

      if (_this.context.history.getCurrentLocation().pathname === to) {
        return;
      }

      _this.go(to, state);
    };

    return _this;
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          href = _props.href,
          state = _props.state,
          children = _props.children,
          isActive = _props.isActive,
          activeStyle = _props.activeStyle,
          activeClassName = _props.activeClassName,
          style = _props.style,
          className = _props.className,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['to', 'href', 'state', 'children', 'isActive', 'activeStyle', 'activeClassName', 'style', 'className', 'type']);

      if (!type) {
        type = 'a';
      }

      if (type === 'a') {
        props['href'] = to; //指向实际地址
      }

      if (isActive) {
        if (typeof isActive === 'function') {
          isActive = isActive();
        } else {
          isActive = !!isActive;
        }
      } else {
        isActive = _HistoryControl2.default.path === to;
      }

      if (isActive) {
        if (activeStyle) style = Object.assign({}, style, activeStyle);
        if (activeClassName) className = className ? className + ' ' + activeClassName : activeClassName;
      }

      return _react2.default.createElement(type, _extends({
        onClick: this.handleClick,
        style: style,
        className: className
      }, props), children);
    }
  }]);

  return Link;
}(_react2.default.Component);

exports.default = Link;

Link.prototype.go = function (to, state) {
  _HistoryControl2.default.go(to, state);
};

if (process.env.NODE_ENV !== 'production') {
  Link.propTypes = {
    state: _propTypes2.default.object,
    to: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string,
    children: _propTypes2.default.any,
    onClick: _propTypes2.default.func
  };
}

Link.contextTypes = {
  history: _propTypes2.default.object
};